<p-dialog [(visible)]="visible" (onHide)="onDialogHide()" [modal]="true" appendTo="body" [resizable]="true"
  [contentStyle]="{'overflow': 'hidden'}">

  <p-header>
    <span>Config Diff Viewer</span>
  </p-header>

  <div #contentDiv style="height: 100%;">

    <div #contentHeaderDiv>

      <div style="display: grid; grid-template-columns: 1fr 1fr;">

        <div>
          <div>
            <label style="margin-right: 3px;">Device</label>
            <input style="margin-right: 3px;" type="text" pInputText placeholder="" disabled="disabled"
              [value]="leftDeviceName">
              <button pButton type="button" icon="fa fa-search"
              title="Select device" (click)="onSelectDevice(1)"></button>
            </div>

            <div style="margin-top: 5px;">
              <label style="margin-right: 3px;">Config</label>
              <select style="padding: 3.75px;" (change)="onUpdateLeftConfig($event)">
                @for (e of leftConfigEntries; track e) {
                  <option value="{{e.index}}"
                    [attr.selected]="(e.configKey == leftConfigKey && e.lastCapture == leftConfigLastCapture) ? '' : null">
                    {{e.configKey}} - {{formatDateHms(e.lastCapture)}}
                  </option>
                }
              </select>
            </div>

          </div>

          <div style="justify-self: end;">

            <div>
              <label style="margin-right: 3px;">Device</label>
              <input style="margin-right: 3px;" type="text" pInputText placeholder="" disabled="disabled"
                [value]="rightDeviceName">
                <button pButton type="button" icon="fa fa-search"
                title="Select device" (click)="onSelectDevice(2)"></button>
              </div>

              <div style="margin-top: 5px;">
                <label style="margin-right: 3px;">Config</label>
                <select style="padding: 3.75px;" (change)="onUpdateRightConfig($event)">
                  @for (e of rightConfigEntries; track e) {
                    <option value="{{e.index}}"
                      [attr.selected]="(e.configKey == rightConfigKey && e.lastCapture == rightConfigLastCapture) ? '' : null">
                      {{e.configKey}} - {{formatDateHms(e.lastCapture)}}
                    </option>
                  }
                </select>
              </div>

            </div>

          </div>

          <div style="text-align: center; margin: 5px;">
            <span>Difference {{curDiffIndex}} of {{diffResult.leftSpans.diffCount}}</span>

            <button type="button" pButton [disabled]="!enablePrevDiff" (click)="prevDiff()"
            title="Move to previous diff" icon="fa fa-arrow-up"></button>

            <button type="button" pButton [disabled]="!enableNextDiff" (click)="nextDiff()"
            title="Move to next diff" icon="fa fa-arrow-down"></button>
          </div>

        </div>

        <div style="display: grid; grid-template-columns: 1fr 1fr;">

          <diff-file #leftFile name="left" [diffSpans]="diffResult.leftSpans" [height]="diffFileHeight" [width]="diffFileWidth"
            [(topCoord)]="topCoord" [(leftCoord)]="leftCoord" [(curDiffIndex)]="curDiffIndex"
          diffTextStyle="left-diff-text" matchTextStyle="match-text" skipTextStyle="skip-text"></diff-file>

          <diff-file #rightFile name="right" [diffSpans]="diffResult.rightSpans" [height]="diffFileHeight" [width]="diffFileWidth"
            [(topCoord)]="topCoord" [(leftCoord)]="leftCoord" [(curDiffIndex)]="curDiffIndex"
          diffTextStyle="right-diff-text" matchTextStyle="match-text" skipTextStyle="skip-text"></diff-file>

        </div>

      </div>

      <p-footer>
        <button type="button" pButton icon="fa fa-close" (click)="onCloseClicked()" label="Close"></button>
      </p-footer>

      <device-selector [header]="'Select a Device'" [(visible)]="displayDeviceSelector"
        [minDevices]="1" [maxDevices]="1" [requireConfig]="true"
        (onCancel)="onDeviceSelectorCancel()" (onOk)="onDeviceSelectorOk($event)">
      </device-selector>

    </p-dialog>
